import { micromodal } from "micromodal";

export const drawer = () => {
  MicroModal.init();

  const button = document.querySelector(".js-drawerButton");
  // const header = document.getElementById("js-header");
  const modalDrawer = document.getElementById("modal-drawer");

  let above768 = false;
  
  window.addEventListener('resize', () => {
      if (!above768 && window.innerWidth >= 768) {
          above768 = true;
          if (window.getComputedStyle(modalDrawer).getPropertyValue('visibility') !== 'hidden') {
              MicroModal.close('modal-drawer');
          }
  
      } else if (above768 && window.innerWidth <= 768) {
          above768 = false;
      }
  });

  button.addEventListener("click", () => {
    if (button.classList.contains("is-open")) {
        button.ariaExpanded = false;
        MicroModal.close("modal-drawer", {
            awaitCloseAnimation: true,
        });
        button.classList.remove("is-open");
        // header.classList.remove("is-open");
    } else {
        button.ariaExpanded = true;
        MicroModal.show("modal-drawer", {
            disableScroll: true, // ページスクロールを無効に
            awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
            onClose: () => {
                button.ariaExpanded = false;
                button.classList.remove("is-open");
                // header.classList.remove("is-open");
            }
        });
        button.classList.add("is-open");
        // header.classList.add("is-open");
    }
  });

  const links = document.querySelectorAll(".js-drawerLink");
  links.forEach((link) => {
    link.addEventListener("click", () => {
      button.ariaExpanded = false;
      MicroModal.close("modal-drawer", {
        awaitCloseAnimation: true,
      });
      button.classList.remove("is-open");
      // header.classList.remove("is-open");
    });
  });
}
